export default __webpack_public_path__ + "img/544c201938a0cc9f0813ea1f1d83a320.svg";